export const headerData = {
  logoUrl: '',
  corporateAccountName: 'McLaren',
  period: 'Q4',
  year: 2026,
  teamMembers: 2338,
  wellscore: 680,
  goalWellScore: 1000,
  changeInScore: {
    thisMonth: 7,
    thisQuarter: 4,
    thisYear: 14,
  },
  avgPointsEarned: {
    thisMonth: 52450,
    thisQuarter: 180500,
    thisYear: 2102350,
  },
};

export const monthsStats = [
  {
    title: 'Energy levels',
    targetPercent: 80,
    averageScore: 30,
    advice:
      'Energy levels improved in December, indicating better engagement or rest. Encourage short breaks, movement prompts, and routines to help maintain consistent energy across members in the coming months.',
    monthsData: [
      { month: 'JUL', actualPercent: 70 },
      { month: 'AUG', actualPercent: 35 },
      { month: 'SEP', actualPercent: 80 },
      { month: 'OCT', actualPercent: 45 },
      { month: 'NOV', actualPercent: 20 },
      { month: 'DEC', actualPercent: 67 },
    ],
  },
  {
    title: 'Stress tolerance',
    targetPercent: 80,
    averageScore: 50,
    advice:
      'Stress tolerance dropped in November but recovered in December. Support this positive trend with ongoing stress awareness, resilience-building content, and access to peer-led or expert wellbeing sessions.',
    monthsData: [
      { month: 'JUL', actualPercent: 66 },
      { month: 'AUG', actualPercent: 47 },
      { month: 'SEP', actualPercent: 80 },
      { month: 'OCT', actualPercent: 45 },
      { month: 'NOV', actualPercent: 23 },
      { month: 'DEC', actualPercent: 78 },
    ],
  },
  {
    title: 'Life balance',
    targetPercent: 80,
    averageScore: 86,
    advice:
      'Life balance showed strong improvement in December after a low in November. Reinforce with guidance on boundaries, recovery time, and healthy daily structures to support continued progress.',
    monthsData: [
      { month: 'JUL', actualPercent: 70 },
      { month: 'AUG', actualPercent: 40 },
      { month: 'SEP', actualPercent: 90 },
      { month: 'OCT', actualPercent: 40 },
      { month: 'NOV', actualPercent: 20 },
      { month: 'DEC', actualPercent: 67 },
    ],
  },
];
